import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './PurchaseConfirmAlert.module.scss';

interface Props {
  labelType: string;
  termsUrl: string;
  lawUrl: string;
}

const PurchaseConfirmAlert = ({ labelType, termsUrl, lawUrl }: Props) => {
  const classes = classNames(css.PurchaseConfirmAlert);
  const intl = useIntl();

  return (
    <div className={classes}>
      <p className={`${css.PurchaseConfirmAlert__Paragraph} ${css.isBold}`}>
        {intl.formatMessage({
          id: `purchases.purchaseConfirmAlert.message1.${labelType}`,
        })}
        <br />
        <span className={css.PurchaseConfirmAlert__Em}>
          {intl.formatMessage({
            id: `purchases.purchaseConfirmAlert.message2.${labelType}`,
          })}
        </span>
      </p>
      <p className={css.PurchaseConfirmAlert__Paragraph}>
        <FormattedMessage
          id={`purchases.purchaseConfirmAlert.message3.${labelType}`}
          values={{
            terms: (
              <Link
                href={termsUrl}
                prefetch={false}
                className={css.PurchaseConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseConfirmAlert.termOfUse',
                })}
              </Link>
            ),
          }}
        />
        <br />
        <FormattedMessage
          id={`purchases.purchaseConfirmAlert.message4.announceForSpecifiedCommercialTransactionsLaw`}
          values={{
            law: (
              <Link
                href={lawUrl}
                prefetch={false}
                className={css.PurchaseConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseConfirmAlert.specifiedCommercialTransactionsLaw',
                })}
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default PurchaseConfirmAlert;
